<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row>
        <el-button size="mini" class="btn" type="primary" @click="onSave" v-if="detailForm.status==='UNSCORED'" v-acl="QSPI_FSPI_SAVE">保存</el-button>
        <!-- 只有在待维护状态显示提交按钮。 -->
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="QSPI_FSPI_SAVE">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onView">查看修改日志</el-button>
      </el-row>
      <div class="within_box">
        <el-form :model="detailForm" ref="detailForm" label-width="100px" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="评价月" prop="scoreStage">
                <el-input v-model="detailForm.scoreStage" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品质分数" prop="qualityScore">
                <el-input v-model="detailForm.qualityScore" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="问卷数" prop="questionScore">
                <el-input v-model="detailForm.questionScore" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status" style="margin-bottom:0">
                <ic-select disabled table="TT_QSPI_FSPI" field="STATUS" v-model="detailForm.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="GC" prop="gc">
                <el-input v-model="detailForm.gc" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-row style="margin-top:10px">
        <el-form :model="formatForm" ref="formatForm" class="searchForm">
          <el-table ref="plxTable" :data="formatForm.tableData" max-height="500" highlight-current-row border>
            <el-table-column align="center" label="Grade" prop="gradeI18n" min-width="120"></el-table-column>
            <el-table-column align="center" :label="'Water Safety & \n Quality'" prop="waterSafetyAndQuality" :render-header="renderHeader" min-width="140">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.waterSafetyAndQuality`" :rules="waterSafetyAndQualityRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.waterSafetyAndQuality" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'3rd Party Audit'" prop="threeRdPartyAudit" min-width="140" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.threeRdPartyAudit`" :rules="threeRdPartyAuditRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.threeRdPartyAudit" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'Gov`t Audit & \n Sampling'" prop="govtAuditAndSampling" min-width="140" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.govtAuditAndSampling`" :rules="govtAuditAndSamplingRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.govtAuditAndSampling" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'Gov`t FS Grading'" prop="govtFsGrading" min-width="140" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.govtFsGrading`" :rules="govtFsGradingRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.govtFsGrading" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'CSAT Quality'" prop="csatQuality" min-width="140" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.csatQuality`" :rules="csatQualityRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.csatQuality" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="'Consumer Feedback \n All (SC)'" prop="consumerFeedbackAllSc" min-width="140"></el-table-column>
            <el-table-column align="center" :label="'Consumer Feedback \n (Ops)'" prop="consumerFeedbackOps" min-width="140" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.consumerFeedbackOps`" :rules="consumerFeedbackOpsRules(scope.$index,scope.row)">
                  <el-input v-model="scope.row.consumerFeedbackOps" :disabled="scope.$index===0?true:false" clearable style="width:100%" @blur="onChangeOps"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remark" min-width="200">
              <template slot-scope="scope">
                <el-form-item :prop="`tableData.${scope.$index}.remark`">
                  <el-input v-model="scope.row.remark" clearable style="width:100%"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-row>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body width="30%">
      <el-form :model="formData" ref="formData" :rules="formDataRules" label-width="100px" style="margin-top: 10px;">
        <el-row>
          <el-col :span="20">
            <el-form-item label="修改原因" prop="modifyReason">
              <el-input v-model="formData.modifyReason" type="textarea" style="width:100%" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容" />
            </el-form-item>
          </el-col>
        </el-row>
        <div align="center">
          <el-button type="primary" @click="onConfirm">确认</el-button>
          <el-button type="primary" @click="onCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import fspiApi from "@/api/fspi/index";
export default {
  name: "fspiDetail",
  components: {
    IcSelect,
  },
  data() {
    let validQualityScore = (rule, value, callback) => {
      console.log('value', value);
      if (!value && value !== 0) {
        this.$my_message('请输入品质分数', 'error')
        callback(new Error(' '));
      } else {
        var reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          this.$my_message('请输入正整数或0', 'error')
          callback(new Error(' '));
        } else {
          callback();
        }
      }
    };
    let validQuestionScore = (rule, value, callback) => {
      console.log('value', value);
      if (!value && value !== 0) {
        this.$my_message('请输入品质分数', 'error')
        callback(new Error(' '));
      } else {
        var reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          this.$my_message('请输入问卷数', 'error')
          callback(new Error(' '));
        } else {
          callback();
        }
      }
    };
    let validModifyReason = (rule, value, callback) => {
      console.log('value', value);
      if (!value) {
        this.$my_message('请输入修改原因', 'error')
        callback(new Error(' '));
      } else {
        callback();
      }
    };
    return {
      formatForm: {
        tableData: []
      },
      detailForm: {
        scoreStage: "",
        qualityScore: "",
        questionScore: "",
        status: "",
        gc: "",
      },
      rules: {
        qualityScore: [
          { required: true, validator: validQualityScore, trigger: 'blur' },
        ],
        questionScore: [
          { required: true, validator: validQuestionScore, trigger: 'blur' },
        ],
      },
      formData: {
        modifyReason: "",
      },
      formDataRules: {
        modifyReason: [
          { required: true, validator: validModifyReason, trigger: 'blur' },
        ],
      },
      scoreStage: this.$route.query.scoreStage,
      dialogVisible: false,
    }
  },
  watch: {
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      fspiApi.getDetail(this.scoreStage).then(res => {
        console.log('详情', res);
        this.detailForm = res.data
        this.formatForm.tableData = res.data.fspiList
      });
    },
    onChangeOps() {
      var num = 0
      var resNum = 0
      this.formatForm.tableData.forEach((ele, index) => {
        if (index !== 0 && ele.consumerFeedbackOps) {
          num += Number(ele.consumerFeedbackOps)
        }
      })
      console.log('num', num);
      resNum = Number(this.detailForm.gc) - Number(num)
      console.log('resNum',resNum);
      this.$set(this.formatForm.tableData[0], 'consumerFeedbackOps',resNum)
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
    onSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          this.$refs['formatForm'].validate((valid1) => {
            if (valid1) {
              var obj = Object.assign({}, this.detailForm)
              obj.fspiList = this.formatForm.tableData
              console.log('obj', obj);
              fspiApi.saveDetail(obj).then(res => {
                console.log('详情', res);
                if (res.code === '200') {
                  this.$message.success('保存成功')
                  this.getDetail()
                }
              });
            }
          })
        }
      })
    },
    onSubmit() {
      if (this.detailForm.status === 'SUBMIT') {
        this.$refs['detailForm'].validate((valid) => {
          if (valid) {
            this.$refs['formatForm'].validate((valid1) => {
              if (valid1) {
                this.dialogVisible = true
              }
            })
          }
        })
      } else {
        this.$refs['detailForm'].validate((valid) => {
          if (valid) {
            this.$refs['formatForm'].validate((valid1) => {
              if (valid1) {
                var obj = Object.assign({}, this.detailForm)
                obj.fspiList = this.formatForm.tableData
                console.log('obj', obj);
                fspiApi.submitDetail(obj).then(res => {
                  console.log('详情', res);
                  if (res.code === '200') {
                    this.$message.success('提交成功')
                    this.$router.go(-1)
                  }
                });
              }
            })
          }
        })
      }
    },
    onConfirm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          var obj = Object.assign({}, this.detailForm)
          obj.modifyReason = this.formData.modifyReason
          obj.fspiList = this.formatForm.tableData
          console.log('obj', obj);
          fspiApi.submitDetail(obj).then(res => {
            console.log('详情', res);
            if (res.code === '200') {
              this.dialogVisible = false
              this.formData.modifyReason = ''
              this.$message.success('提交成功')
              this.$router.go(-1)
            }
          });
        }
      })
    },
    onView() {
      this.$router.push({
        path: '/qspiFSPI/history',
        query: {
          scoreStage: this.scoreStage
        }
      })
    },
    waterSafetyAndQualityRules(index, row) {
      return (this.rules["waterSafetyAndQuality"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入Water Safety & Quality', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    threeRdPartyAuditRules(index, row) {
      return (this.rules["threeRdPartyAudit"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入3rd Party Audit', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    govtAuditAndSamplingRules(index, row) {
      return (this.rules["govtAuditAndSampling"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入Gov`t Audit & Sampling', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    govtFsGradingRules(index, row) {
      return (this.rules["govtFsGrading"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入Gov`t FS Grading', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    csatQualityRules(index, row) {
      return (this.rules["csatQuality"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入CSAT Quality', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    consumerFeedbackOpsRules(index, row) {
      return (this.rules["consumerFeedbackOps"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (!value && value !== 0) {
              this.$my_message('请输入Consumer Feedback(Ops)', 'error')
              return callback(new Error(' '));
            }
            var reg = /^[0-9]\d*$/
            if (!reg.test(value)) {
              this.$my_message('请输入正整数或0', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    remarkRules(index, row) {
      return (this.rules["remark"] = [
        {
          validator: (rule, value, callback) => {
            // 验证不为空
            if (this.detailForm.status === "SUBMIT" && !value) {
              this.$my_message('请输入备注', 'error')
              return callback(new Error(' '));
            }
            callback();
          },
          trigger: "blur"
        }
      ]);
    },
    routerBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.content_box {
  background-color: #fff;
  height: 100%;
  padding: 5px 10px;
}
.within_box {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 8px;
  margin-top: 5px;
}
</style>